export enum LeadReviewStatusEnum {
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUESTED = 'REQUESTED',
  RECEIVED = 'RECEIVED',
}

export const LEAD_REVIEW_STATUS_VALUES: LeadReviewStatusEnum[] = [
  LeadReviewStatusEnum.NOT_REQUESTED,
  LeadReviewStatusEnum.REQUESTED,
  LeadReviewStatusEnum.RECEIVED,
];

export const DEFAULT_LEAD_REVIEW_STATUS = LeadReviewStatusEnum.NOT_REQUESTED;

export function toLeadReviewStatus(
  value: string | null | undefined,
): LeadReviewStatusEnum {
  return LEAD_REVIEW_STATUS_VALUES.includes(value as LeadReviewStatusEnum)
    ? (value as LeadReviewStatusEnum)
    : DEFAULT_LEAD_REVIEW_STATUS;
}
